import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type RingsIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const RingsIcon = ({
  width = 24,
  height = 24,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: RingsIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="8.16665" cy="15.0104" r="5.41665" stroke={color} strokeWidth={1.5} />
      <circle cx="15.8333" cy="15.0104" r="5.41665" stroke={color} strokeWidth={1.5} />
      <path
        d="M13.2986 3.25586C13.3315 3.2584 13.3584 3.26097 13.3738 3.2627C13.3799 3.26337 13.382 3.2636 13.3826 3.26367C13.3817 3.26358 13.3758 3.26328 13.368 3.2627C13.362 3.26226 13.342 3.26074 13.3162 3.26074C13.4032 3.26074 13.879 3.26294 14.2801 3.66406C14.3735 3.75744 14.7511 4.09747 14.8133 4.71973C14.8535 5.12296 14.6997 5.49853 14.5779 5.7334C14.4456 5.98869 14.2744 6.22089 14.1277 6.37598C13.8837 6.63392 13.3567 7.10902 13.2684 7.17969C13.1835 7.24758 12.9639 7.40671 12.7889 7.5332C12.6964 7.60005 12.6087 7.6643 12.5438 7.71094C12.5113 7.73425 12.4843 7.75324 12.4656 7.7666C12.4563 7.77326 12.4491 7.77866 12.4442 7.78223C12.4417 7.784 12.4396 7.78521 12.4383 7.78613L12.4363 7.78711L11.9998 8.09961L11.5633 7.78711L11.5613 7.78613C11.5601 7.78526 11.5586 7.78377 11.5565 7.78223C11.5515 7.77865 11.5433 7.77329 11.534 7.7666C11.5154 7.7533 11.4891 7.73406 11.4568 7.71094C11.3918 7.66428 11.3033 7.60008 11.2108 7.5332C11.0357 7.40667 10.8161 7.24752 10.7313 7.17969C10.6426 7.10869 10.1157 6.63377 9.87189 6.37598C9.72523 6.22094 9.55498 5.98859 9.42267 5.7334C9.30094 5.49852 9.14709 5.12299 9.18732 4.71973L9.20294 4.60254C9.30143 4.03872 9.66951 3.73052 9.73615 3.66406L9.88165 3.53613C10.221 3.27522 10.5559 3.26074 10.6668 3.26074C10.6413 3.26074 10.6215 3.26237 10.617 3.2627C10.6156 3.2628 10.6143 3.26358 10.6131 3.26367C10.6138 3.2636 10.6147 3.26283 10.616 3.2627C10.6326 3.26097 10.6606 3.25729 10.6942 3.25488C10.7608 3.2501 10.8536 3.24707 10.9617 3.25391C11.1437 3.26546 11.4087 3.30894 11.6707 3.45996L11.782 3.53125L11.907 3.62695C11.9408 3.65503 11.9732 3.68617 12.0067 3.7168C12.0833 3.64788 12.1599 3.58371 12.2342 3.53125C12.5232 3.32728 12.8248 3.26816 13.035 3.25391C13.1419 3.24668 13.2331 3.25079 13.2986 3.25586Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
      />
    </svg>
  );
};
